import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
////////////////////////////////////////////////////////////////////
import appRoutes from '@/routes/types/appRoutes';
import { useCustomDispatch, useCustomSelector } from '@/core/redux/hooks';
import { NavItem } from './components';
import { Network } from '../../icons/Network';
import { useEffect } from 'react';
import { setPendingEarnAction } from '@/core/redux/slices';

export const Nav: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();
	const dispatch = useCustomDispatch();

	/*********************
	// #region Redux
	**********************/
	const { navigation } = useCustomSelector((state) => state.navigation);
	const { rewards, youtubeRewards, dailyRewards } = useCustomSelector(
		(state) => state.rewards
	);

	/*********************
     // #region Observable
    **********************/
	useEffect(() => {
		// this function returns a true if there is any reward or youtube reward with the property requestedByUser is false or if the availableForCollectiong is true or if there is an available DailyReward
		const checkRewards = () => {
			return (
				rewards.some(
					(reward) =>
						!reward.requestedByUser || reward.availableForCollecting
				) ||
				youtubeRewards.some(
					(reward) =>
						!reward.requestedByUser || reward.availableForCollecting
				) ||
				dailyRewards.some((reward) => reward.availableToday)
			);
		};
		const hasUnrequestedOrCollectibleRewards = checkRewards();

		dispatch(setPendingEarnAction(hasUnrequestedOrCollectibleRewards));
	}, [rewards, youtubeRewards, dailyRewards]);

	/*********************
	// #region Template
	**********************/
	return (
		<div
			className={`max-w-6xl sm:max-w-sm p-2 rounded-[30px] mb-6 mx-3 border-gradient-tr-nav-menu-bg-menu gradient-border-2 cursor-pointer shadow-lg shadow-customer-500/50 z-10 fixed bottom-0 left-0 right-0`}
		>
			<div className="flex justify-between">
				<Link
					to={'/'}
					className={`${
						navigation === 'dashboard'
							? 'bg-vottun-600 shadow-lg shadow-vottun-600/50'
							: ''
					} flex flex-col items-center py-2 gap-2 rounded-[20px] flex-1`}
				>
					<div className="min-h-6 flex items-center w-12 justify-center">
						<Network />
					</div>
					<p className="text-xs">{t('nav.network')}</p>
				</Link>
				{appRoutes
					.filter((route) => route.isMenu)
					.map((route) => (
						<NavItem
							key={route.id}
							isActive={navigation === route.state}
							item={route}
						/>
					))}
			</div>
		</div>
	);
};
